import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';


const EditLeaveCredebility = ({Id, list}) => {
    const [leaveCredData, setLeaveCredData] = useState(null);

    const fetchData = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves_credebility/${Id}`)
            .then(response => {
                setLeaveCredData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setLeaveCredData([]); 
            });
    }

    useEffect(() => {
        if (Id) {
            fetchData(Id);
        }
    },[Id]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        leave_type: Yup.string().required('leave type is a required field'),
        total_annual_leaves: Yup.string().required('total annual leaves is a required field')
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (leaveCredData) {
            reset(leaveCredData);
        }
    }, [leaveCredData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/leaves_credebility/${Id}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_leave_cred_${Id}`);
                list();
            })
            .catch(({response:{data}}) => {
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    if (!Id || !leaveCredData) {
        return null;
    }

    return (
        <div id={`edit_leave_cred_${Id}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Leave Credebility</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Leave Type <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={leaveCredData.leave_type} {...register('leave_type')}/>
                                        <div className="text-sm text-danger">
                                            {errors.leave_type && <p>{errors.leave_type.message}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="input-block mb-3">
                                        <label className="col-form-label">Total Annual Leaves <span className="text-danger">*</span></label>
                                        <input className="form-control" type="text" defaultValue={leaveCredData.total_annual_leaves} {...register('total_annual_leaves')}/>
                                        <div className="text-sm text-danger">
                                            {errors.total_annual_leaves && <p>{errors.total_annual_leaves.message}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditLeaveCredebility
